import ModalContent from './Content';
import ModalRoot from './Root';
import ModalTrigger from './Trigger';

const Modal = {
  Root: ModalRoot,
  Trigger: ModalTrigger,
  Content: ModalContent,
};

export default Modal;
